import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ionic-vhframeworks',
  template: `
    <p>
      ionic-vhframeworks works!
    </p>
  `,
  styles: [
  ]
})
export class IonicVhframeworksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
